import React from 'react';
import MainContent from './layout/MainContent';
import ReportForm from './reports/ReportForm';
import { ICON_DOWNLOAD } from './extras/icons';
//Función principal
const Reports = () => {
    //Nodos
    const nodes = [
        {
            name: 'Audiencias',
            link: '/'
        },{
            name: 'Reportes'
        }
    ];
    //Acciones
    const actions  = []
    //Renderizo
    return (
        <MainContent 
            title='Reportes' 
            subtitle='Formulario' 
            nodes={nodes}
            actions={actions}
            component={ReportForm} />
    );
};

export default Reports;